import { render, staticRenderFns } from "./TableLabel.vue?vue&type=template&id=fade4bae&scoped=true&"
import script from "./TableLabel.vue?vue&type=script&lang=js&"
export * from "./TableLabel.vue?vue&type=script&lang=js&"
import style0 from "./TableLabel.vue?vue&type=style&index=0&id=fade4bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fade4bae",
  null
  
)

export default component.exports